const actionTypes = require('constants/actionTypes');
const get = require('lodash/object/get');
const uniq = require('lodash/array/uniq');
const trim = require('lodash/string/trim');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const moment = require('moment');
// @ constants
const { DATE_FORMAT_API, TRANSFER_MAX_IMPORT, TRANSFER_MIN_IMPORT } = require('constants/index');

const receivedTransfersRequest = (accountId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_REQUEST,
    payload: {
        accountId
    }
})

const receivedTransfersNextPageRequest = (accountId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_NEXT_PAGE_REQUEST,
    payload: {
        accountId
    }
})

const receivedTransfersSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        transfers: get(data, 'listaTransRecibidas.transRecibidas', [])
    }
})

const receivedTransfersFailure = (error, accountId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_FAILURE,
    payload: {
        accountId,
        error
    }
})

const requestNextAccountTransactionsPageSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_RECEIVED_TRANSFERS_NEXT_PAGE_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        transfers: get(data, 'listaTransRecibidas.transRecibidas', [])
    }
})

function getReceivedTransfers(dispatch, accountId, product, contractNumber, filters, accountHoldersNames) {
    // If there's no toDate defined, we use today minus 5 years (arbitrary long date)
    let toDate = get(filters, 'toDate') || moment().startOf('day');
    // If there's no fromDate defined, we use today as a limit
    let fromDate = get(filters, 'fromDate') || moment().startOf('day').subtract(5, 'year')

    let toAmount = get(filters, 'toAmount');
    let fromAmount = get(filters, 'fromAmount');
    let amountCurrency = get(filters, 'amountCurrency');

    const requestData = {
        query: {
            producto: product,
            numeroContrato: contractNumber,
            fechaDesde: fromDate.format(DATE_FORMAT_API),
            fechaHasta: toDate.format(DATE_FORMAT_API)
        }
    }

    if (amountCurrency) {
        requestData.query.importeDesde = TRANSFER_MIN_IMPORT;
        requestData.query.importeHasta = TRANSFER_MAX_IMPORT
        requestData.query.divisaImporteDesde = amountCurrency;
        requestData.query.divisaImporteHasta = amountCurrency;
    }

    if (fromAmount || toAmount) {
        requestData.query.importeDesde = fromAmount || TRANSFER_MIN_IMPORT;
        requestData.query.importeHasta = toAmount || TRANSFER_MAX_IMPORT
    }

    dispatch(receivedTransfersRequest(accountId));
    return APIGet({
        dispatch,
        endpoint: 'receivedTransfers',
        url: apiURLBuilder.getURL('receivedTransfers'),
        params: requestData
    })
    .then(response => {
        get(response, 'listaTransRecibidas.transRecibidas', []).forEach( transfer => {
            transfer.isPass = accountHoldersNames.includes(trim(transfer.nombreBeneficiario));
        })
        return dispatch(receivedTransfersSuccess(response, accountId))
    })
    .catch( response => {
        if (!!response.error) {
            dispatch(receivedTransfersFailure(response.error, accountId))
        }
        else throw response;
    })
}

const requestReceivedTransfers = (accountId) => (dispatch, getState) => {
    const immAccounts = getState().accounts;
    const immAccount = immAccounts.get('byId').get(accountId);
    // we identify all accounts holders names, to filter transfer between own accounts
    const accountHoldersNames = uniq(immAccounts.get('byOrder').map( accountId => {
        return immAccounts.getIn(['byId', accountId, 'accountHolder'])
    }).toJS())
    const immReceivedTransfersFilters = getState().receivedTransfers.get('filters');
    let filters = {};

    if (immReceivedTransfersFilters) {
        filters = {
            fromDate: immReceivedTransfersFilters.get('date').get('from'),
            toDate: immReceivedTransfersFilters.get('date').get('to'),
            fromAmount: immReceivedTransfersFilters.get('amount').get('from').get('amount'),
            toAmount: immReceivedTransfersFilters.get('amount').get('to').get('amount'),
            amountCurrency: immReceivedTransfersFilters.get('currency').get('value')
        }
    }

    return getReceivedTransfers(dispatch, accountId, immAccount.get('newProduct'), immAccount.get('newContractNumber'), filters, accountHoldersNames);
}

const requestReceivedTransfersNextPage = (accountId) => (dispatch, getState) => {
    const immAccounts = getState().accounts;
    const nextPageURL = getState().receivedTransfers.get(accountId).get('nextPage');
    // we identify all accounts holders names, to filter transfer between own accounts
    const accountHoldersNames = uniq(immAccounts.get('byOrder').map( accountId => {
        return immAccounts.getIn(['byId', accountId, 'accountHolder'])
    }).toJS())

    dispatch(receivedTransfersNextPageRequest(accountId));
    return APIGet({
        dispatch,
        endpoint: 'receivedTransfers',
        url: nextPageURL
    })
    .then(response => {
        get(response, 'listaTransRecibidas.transRecibidas', []).forEach( transfer => {
            transfer.isPass = accountHoldersNames.includes(trim(transfer.nombreBeneficiario));
        })
        return dispatch(requestNextAccountTransactionsPageSuccess(response, accountId))
    })
    .catch( response => {
        if (!!response.error) {
            dispatch(receivedTransfersFailure(response.error, accountId))
        }
        else throw response;
    })
}

const setReceivedTransfersFilters = (filters) => ({
    type: actionTypes.SET_RECEIVED_TRANSFERS_FILTERS, // tagged for analytics
    payload: {
        filters
    }
})

const resetReceivedTransfersFilter = (filter) => ({
    type: actionTypes.RESET_RECEIVED_TRANSFERS_FILTER,
    payload: {
        filter
    }
})

const clearReceivedTransfersFilters = () => ({
    type: actionTypes.CLEAR_RECEIVED_TRANSFERS_FILTERS // tagged for analytics
})

module.exports = {
    requestReceivedTransfers,
    requestReceivedTransfersNextPage,
    setReceivedTransfersFilters,
    resetReceivedTransfersFilter,
    clearReceivedTransfersFilters
}
